import { render, staticRenderFns } from "./ProvisionedOrdersBeauty.vue?vue&type=template&id=59b43399"
import script from "./ProvisionedOrdersBeauty.vue?vue&type=script&lang=js"
export * from "./ProvisionedOrdersBeauty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports